import React from 'react';
import { Box, Typography } from '@mui/material';

interface SectionLabelProps {
  Icon: any,
  label: string,
}

export const SectionLabel = ({
  Icon,
  label
}: SectionLabelProps) => {
  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      color: '#9D9D9D',
    }}>
      <Icon fontSize="inherit"/>
      <Typography sx={{
        fontWeight: '400',
        fontSize: '14px',
        marginLeft: '8px',
      }}>
        {label}
      </Typography>
    </Box>
  )
}

